import { render, staticRenderFns } from "./4mScenario.vue?vue&type=template&id=7066e861"
import script from "./4mScenario.vue?vue&type=script&lang=js"
export * from "./4mScenario.vue?vue&type=script&lang=js"
import style0 from "./4mScenario.vue?vue&type=style&index=0&id=7066e861&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7066e861')) {
      api.createRecord('7066e861', component.options)
    } else {
      api.reload('7066e861', component.options)
    }
    module.hot.accept("./4mScenario.vue?vue&type=template&id=7066e861", function () {
      api.rerender('7066e861', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/action/4mScenario.vue"
export default component.exports